import { booleanAttribute, Component, input } from '@angular/core';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [TranslatePipe],
})
export class LoadingComponent {
  readonly message = input<string | null>(null);
  /** Scope the overlay to the nearest positioned ancestor instead of the viewport. */
  readonly inline = input(false, { transform: booleanAttribute });
}
